import React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";

export const AuthContent:React.FunctionComponent<any> = ({ children }) => {
  return (
    <Container component="main" maxWidth="sm">
      <CssBaseline/>
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: '#FFFFFF',
          p: 6
        }}
      >
        {children}
      </Box>
    </Container>
  )
}

export default AuthContent